import React from 'react'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import addFont from '../../assets/fonts/fonts'
import moment from 'moment'
import { getInitials } from '../../utils/smallHelpers'


const PdfPrint = ({ data, fio, facultLabel, groupLabel }) => {

  const createDocData = () => {

    let lastY = 10

    const getY = (indent, newValue) => {
      let newY = newValue ? newValue + indent : lastY + indent
      if (newY > doc.internal.pageSize.height - 20) {
        doc.addPage('a4', orientation)
        newY = 10
      }
      lastY = newY
      return newY
    }

    addFont(jsPDF.API)
    const orientation = 'p'
    const doc = new jsPDF({ orientation });

    doc.setFont("TimesNewRoman").setFontSize(17);
    doc.text(fio, doc.internal.pageSize.width / 2, getY(10), "center")
    doc.setFont(undefined, 'normal').setFontSize(15);
    { facultLabel && doc.text(facultLabel, doc.internal.pageSize.width / 2, getY(9), "center") }
    { groupLabel && doc.text(`${groupLabel} группа`, doc.internal.pageSize.width / 2, getY(9), "center") }

    doc.setFontSize(17);
    doc.text('Информация о достижении', doc.internal.pageSize.width / 2, getY(15), "center")


    doc.setFontSize(14).setFont(undefined, 'normal')

    doc.autoTable({
      html: `#gradeDescriptionTable`,
      styles: { font: 'TimesNewRoman', fontSize: 14 },
      bodyStyles: {
        textColor: '#000',
      },
      columnStyles: {
        0: { columnWidth: 80 },
        // 1: { fontStyle: 'bold' },
      },
      didParseCell: (data) => {
        // data.column.index && (data.cell.styles.fontStyle = 'bold')
        data.cell.styles.fillColor = [255, 255, 255]
      },
      startY: getY(10)
    })

    doc.text('Должность', doc.internal.pageSize.width / 2, getY(20, doc.autoTableEndPosY()), 'center')
    doc.text('Воинское звание', 20, getY(10))

    doc.text(`_______________________ ${getInitials(fio)}`, 65, getY(10))
    doc.text(`"___" ______________ 202 __ г.`, 20, getY(10))

    doc.addPage("a4", orientation);
    doc.deletePage(doc.getCurrentPageInfo().pageNumber);

    return doc
  }

  const toPdf = () => {
    const doc = createDocData()
    doc.save(`Описание достижения.pdf`)
  }


  return (
    <>
      <button onClick={toPdf} type='button'>Печать</button>
      <table id='gradeDescriptionTable' hidden>
        <tr>
          <td>Название достижения:</td>
          <td>{data.title}</td>
        </tr>
        <tr>
          <td>Номер документа (при наличии):</td>
          <td>{data.document_number}</td>
        </tr>
        <tr>
          <td>Дата:</td>
          <td>{data.document_date}</td>
        </tr>
        <tr>
          <td>Срок действия (при наличии):</td>
          <td>{data.document_date_to}</td>
        </tr>
        <tr>
          <td>Результат:</td>
          <td>{data.achievement_result}</td>
        </tr>
        <tr>
          <td>Дополнительная информация, которую необходимо указать:</td>
          <td>{data.info}</td>
        </tr>
        <tr>
          <td>{data.link_type === 1 ? 'Файл:' : 'Ссылка:'}</td>
          <td>{data.link}</td>
        </tr>
      </table>
    </>
  )
}

export default PdfPrint